import * as Cookie from "js-cookie";
import {observable} from "mobx";
import {push} from "@netless/i18n-react-router";
import * as H from "history";

export class MiniPersistStore {

    @observable
    private _token: string = "";
    @observable
    private _adminEnable: string = "";

    public get token(): string {
        if (this._token && this._token.length > 0) {
            return this._token;
        } else {
            const token = Cookie.get("token") || "";
            this._token = token;
            return token;
        }
    }

    public get adminEnable(): string {
        if (this._adminEnable && this._adminEnable.length > 0) {
            return this._adminEnable;
        } else {
            const adminEnable = Cookie.get("adminEnable") || "";
            this._adminEnable = adminEnable;
            return adminEnable;
        }
    }

    public set token(token: string) {
        Cookie.set("token", token);
        this._token = token;
    }


    public set adminEnable(adminEnable: string) {
        if (adminEnable === "false") {
            Cookie.set("adminEnable", "");
            this._adminEnable = "";
        } else {
            Cookie.set("adminEnable", adminEnable);
            this._adminEnable = adminEnable;
        }
    }

    public isLogin(history: H.History): void {
        const tokenDone = this.token && this.token.length > 0;
        const adminEnableDone = this.adminEnable && this.adminEnable.length > 0;
        if (tokenDone && adminEnableDone) {
            push(history, "/");
        }
    }

    public logout(history: H.History): void {
        this.token = "";
        this.adminEnable = "";
        push(history, "/login/");
    }
}
export const miniPersistStore = new MiniPersistStore();



// WEBPACK FOOTER //
// ./src/models/MiniPersistStore.ts